import React, { useEffect, useState, useRef } from "react";
import useOnlineStatus from "../../useOnlineStatus";
import { Avatar, Button, FormControl, Grid, InputLabel } from "@material-ui/core";
import { DataGrid } from "@mui/x-data-grid";
import { post } from "../../api/api";
import { decrypt, getDateWithFormat, getWeekDay } from "../../utils/utils";
import { format } from "date-fns";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { getAllOfTable } from "../../offlineManager/localbase";
import { ApiUrls } from "../../api/baseURL";
import './inmateScanReport.scss'
import { useNavigate } from "react-router-dom";
import { metaDataConstants } from "../../utils/Constants/constants-en";

const InmateScanReport = () => {

    const isOnline = useOnlineStatus();
    const [rows, setRows] = useState([])
    const [account, setAccount] = useState([]);
    const [currentAccount, setCurrentAccount] = useState({ key: -1, label: "-- Select --" });
    const [showOfflineText, setShowOfflineText] = useState(true);
    let navigate = useNavigate();

    useEffect(() => {
        if (isOnline) {
            setShowOfflineText(false);
            getAccounts();
        }
    }, []);

    const getPatientName = (firstName, lastName) => {
        const patientFirstName = decrypt(firstName);
        const patientLastName = decrypt(lastName);
        return patientLastName + ', ' + patientFirstName;
    }
    const getAccounts = async () => {
        let accountsDetails = await getAllOfTable('AccountDetails')
        if (accountsDetails[0].accountDetails) {
            let accDetails = getDropdownData(
                accountsDetails[0].accountDetails,
                "id",
                "accountName"
            );
            setAccount(accDetails);
        }
    }
    const getDropdownData = (optionsArr, key, label) => {
        const arr = optionsArr?.map((item) => {
            return {
                key: item[key],
                label: item[label]?.charAt(0)?.toUpperCase() + item[label]?.slice(1),
            };
        });
        arr.unshift({ key: -1, label: "-- Select --" });
        return arr;
    };
    const getInmateRecordDetails = async (accId) => {
        const payload = {
            accountId: accId,
            orderDate: getDateWithFormat(metaDataConstants.yearMonthDateFormat)
        }
        const response = await post(ApiUrls().INMATE_ORDER_DETAIL, payload)
            .catch(err => {
                console.error("Error", err)
            })
        const result = response.data.result
        if (response?.status === 200 && result) {

            let updatedArr = result.map(element => {
                const name = getPatientName(element.patientFirstName, element.patientLastName)
                const imageUrl = `data:${element.documentType};base64,${element.imageString}`;
                let obj = { id: element.patientId, location: element.locationName, mealPeriod: element.mealservetime, code: element.patientCode, name: name, room: element.roomNumber, image: { avatar: imageUrl } }
                return obj;
            });
            setRows(updatedArr)
        }
    }

    const onChangeAccount = (e, node) => {
        setCurrentAccount({ key: node.props.value, label: node.props.children });
        getInmateRecordDetails(e.target.value)
    }

    const handleBackClick = () => {
        navigate('/inmate_scanning')
    }

    return (
        <div className="inmateScanReportContainer">

            <Grid container style={{ margin: '10px 0 10px 15px' }}>
                <Grid xs={6} md={6}>
                    <h2 className="form-title">{metaDataConstants.inmateRecord}</h2>
                </Grid>
                <Grid xs={3} md={3}>
                </Grid>

                <Grid xs={3} md={3} style={{ textAlign: 'center' }}>
                    <Button variant="contained" className="submitButton btn btn-primary" color='success' onClick={handleBackClick}>{metaDataConstants.back}</Button>
                </Grid>
            </Grid>
            {showOfflineText ? (
                <p style={{ margin: "5%", color: "#c93838", fontSize: '1.1rem', textAlign: 'center' }}>
                    {metaDataConstants.youAreOffline}
                </p>
            ) : <>
                <Grid container
                    alignItems="center"
                    justifyContent="center"
                >
                    <Grid xs={4} md={4} style={{ textAlign: 'center', marginTop: '17px' }}>
                        <div>{getWeekDay()} - {getDateWithFormat('MM/dd/yyyy')}</div>
                    </Grid>
                    <Grid xs={4} md={4} style={{ textAlign: 'center' }}>
                        <InputLabel id="account-name-label" style={{ fontSize: '0.8rem', marginBottom: '10px' }}>{metaDataConstants.accountName}</InputLabel>
                        <Select style={{ height: '30px', textAlign: 'center', borderRadius: '20px' }} value={currentAccount.key} onChange={onChangeAccount} variant='outlined' labelId="account-name-label"
                            id="account-select" label={metaDataConstants.accountName}>
                            {account.map(acc => <MenuItem key={acc.key} value={acc.key}>{acc.label}</MenuItem>)}
                        </Select>
                    </Grid>
                    <Grid xs={4} md={4}>
                    </Grid>
                </Grid>
                <br />
                <DataGrid
                    style={rows.length > 0 ? {} : { height: '100px' }}
                    columns={[
                        {
                            field: 'image', headerName: 'Picture', width: 60, editable: false, filterable: false, sortable: false,
                            renderCell: (params) => {
                                return (
                                    <>
                                        <Avatar src={params.value.avatar} />
                                    </>
                                );
                            }
                        },
                        { field: 'code', headerName: 'Barcode', width: 120, editable: false },
                        { field: 'name', headerName: 'Name', width: 180, editable: false },
                        { field: 'location', headerName: 'Location', width: 180, editable: false },
                        { field: 'mealPeriod', headerName: 'Meal Period', width: 180, editable: false },
                        { field: 'room', headerName: 'Room no', width: 150, editable: false },
                    ]}
                    rows={rows}
                />
            </>}
        </div>
    )
}

export default InmateScanReport;